import { StyledHeader, StyledLogo } from "./drawer.styles";
import { useDrawerContext } from "./DrawerContextProvider";

export const DrawerHeader = () => {
  const { isDrawerOpen } = useDrawerContext();
  return (
    <>
      <StyledLogo $isDrawerOpen={isDrawerOpen} />
      {isDrawerOpen && <StyledHeader />}
    </>
  );
};
